import { AuthRepository } from "@/domain/repository/auth-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class ExchangeAESKeyUsecase {
  //MARK:- init
  constructor(private readonly authRepo: AuthRepository) {}

  //MARK: - execute
  async execute(): Promise<SATResult<void, SATError>> {
    console.log("[ExchangeAESKeyUsecase] :: execute :: RSA 키 교환 시작");
    const aesKeyExchangeResult = await this.authRepo.exchangeAndSaveAESecretKeyByCookie();
    if (aesKeyExchangeResult.isFailure) {
      return SATResult.failure(aesKeyExchangeResult.error);
    }

    console.log("[ExchangeAESKeyUsecase] :: execute :: RSA 키 교환 완료 & AES 대칭키 저장 완료");
    return SATResult.success(undefined);
  }
}
